function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.813,14.861L4.19,14.861M11.813,14.861L12.425,14.861C13.277,14.861 13.703,14.861 14.029,14.695C14.316,14.548 14.55,14.315 14.696,14.028C14.862,13.702 14.862,13.276 14.862,12.424L14.862,5.88C14.862,5.538 14.862,5.366 14.825,5.203C14.793,5.058 14.739,4.918 14.666,4.788C14.585,4.643 14.471,4.517 14.247,4.268L12.146,1.934C11.887,1.645 11.755,1.499 11.597,1.394C11.455,1.299 11.298,1.23 11.132,1.187C10.946,1.139 10.745,1.139 10.345,1.139L3.58,1.139C2.726,1.139 2.299,1.139 1.973,1.306C1.686,1.452 1.453,1.685 1.307,1.972C1.141,2.298 1.141,2.725 1.141,3.579L1.141,12.421C1.141,13.275 1.141,13.702 1.307,14.028C1.453,14.315 1.686,14.548 1.973,14.695C2.299,14.861 2.725,14.861 3.578,14.861L4.19,14.861M11.813,14.861L11.813,11.961C11.813,11.109 11.813,10.683 11.647,10.357C11.501,10.07 11.267,9.837 10.98,9.691C10.654,9.525 10.227,9.525 9.373,9.525L6.629,9.525C5.775,9.525 5.348,9.525 5.022,9.691C4.735,9.837 4.502,10.07 4.356,10.357C4.19,10.683 4.19,11.11 4.19,11.964L4.19,14.861M10.288,4.189L5.714,4.189",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "1.3px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSelected);
export default __webpack_public_path__ + "static/media/save_selected.f23270a378b35c156398afdeeb24e7f3.svg";
export { ForwardRef as ReactComponent };